<template>
  <div>
    <page-header title="Redeem Gift Card" />

    <div class="section">
      <div class="container max-width-mobile center">
        <div
          v-if="isLoading"
          class="loader"
        />

        <div v-else-if="!currentUser.accountId">
          <span class="icon icon--block icon--large far fa-gift-card gray extra-spacing" />

          <p class="bigger dark extra-spacing">Please sign in or create an account to redeem your gift card.</p>

          <button
            class="button button--primary button--large"
            type="button"
            @click="$openModal('signIn')"
          >
            Sign In
          </button>

          <div class="title-separator">
            <p class="title title--6 uppercase">
              or
            </p>
          </div>

          <button
            class="button button--secondary button--small button--auto-width"
            type="button"
            @click="$openModal('createAccount')"
          >
            Create Account
          </button>
        </div>

        <div v-else-if="failedToLoad">
          <p class="extra-spacing">Gift card redemption failed. Please try again later or contact support.</p>

          <router-link
            class="button button--primary button--auto-width"
            :to="{
              name: 'paymentMethodsGiftCards',
              params: {
                merchantId: $route.params.merchantId
              }
            }"
          >
            View Gift Cards
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import events from '@/services/events';
  import { mapGetters } from 'vuex';



  export default {
    name: 'OrderGiftingRedemptionPage',

    metaInfo() {
      return {
        title: 'Redeem Gift Card'
      };
    },

    data() {
      return {
        failedToLoad: false,
        isLoading: false
      };
    },

    computed: {
      ...mapGetters('session', ['currentUser'])
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    methods: {
      createdHandler() {
        this.redeemCard();
        events.on('signed-in', this.redeemCard);
      },

      destroyedHandler() {
        events.off('signed-in', this.redeemCard);
      },

      async redeemCard() {
        try {
          if (!this.currentUser.accountId) {
            return;
          }

          this.isLoading = true;

          const card = await this.$store.dispatch('giftCards/redeemCard', {
            giftId: this.$route.query.giftId
          });

          this.$openModal('giftCardDetails', {
            card
          });

          this.$router.replace({
            name: 'paymentMethodsGiftCards',
            params: {
              merchantId: this.$route.params.merchantId
            }
          });
        }

        catch (error) {
          errorHandlers.generic(error);
          this.failedToLoad = true;
        }

        finally {
          this.isLoading = false;
        }
      }
    }
  };
</script>
